import React, { Dispatch, SetStateAction } from 'react';
import Modal from '../../../../../components/modals/modal';
import GroupAnimalNotes from './index';
import css from '../view.module.css';
import {
  ButtonComponent,
  ButtonStyling,
} from '../../../../../components/form/elements/button';
import { useTranslation } from 'react-i18next';

interface Props {
  animalGroupId: string;
  setAnimalGroupId: Dispatch<SetStateAction<string>>;
  apiRoutePrefix: string;
}

export default function NotesModal({
  animalGroupId,
  setAnimalGroupId,
  apiRoutePrefix,
}: Props) {
  const { t } = useTranslation();

  return (
    <div>
      {animalGroupId !== '' && (
        <Modal
          className={css['modal-group-animal-note']}
          classNameBody={'body-bottom'}
          buttonsClassName={'buttons-bottom'}
          visible={!!animalGroupId}
          buttons={
            <ButtonComponent
              name={'close'}
              styling={ButtonStyling.cancel}
              label={t('close')}
              click={() => setAnimalGroupId('')}
            />
          }
          body={
            <GroupAnimalNotes
              animalGroupId={animalGroupId}
              apiRoutePrefix={apiRoutePrefix}
            />
          }
          contentClassName="content-bottom"
          onClose={() => setAnimalGroupId('')}
        />
      )}
    </div>
  );
}
